/**
 * MSG Icon SVG Component
 * A blue Outlook email icon with a white envelope glyph.
 */
export function MsgIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="12" y="8" width="40" height="48" rx="2" fill="#0072C6" />
      <path
        d="M12 10C12 8.89543 12.8954 8 14 8H38L52 22V54C52 55.1046 51.1046 56 50 56H14C12.8954 56 12 55.1046 12 54V10Z"
        fill="#005A9E"
      />
      <path d="M38 8L52 22H40C38.8954 22 38 21.1046 38 20V8Z" fill="#0072C6" />
      <rect x="20" y="30" width="24" height="16" rx="1.5" fill="white" />
      <path
        d="M21 31.5L32 39L43 31.5"
        stroke="#0072C6"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
